import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Card,
  CardContent,
  Divider,
  Chip,
  Box,
  CircularProgress,
  Tabs,
  Tab,
  useTheme
} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import { injectIntl } from 'react-intl';
import * as calledsActions from '../../../../redux/actions/calleds';
import InfoIcon from '@mui/icons-material/Info';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import DescriptionIcon from '@mui/icons-material/Description';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Api from '../../../../services/api';
import { getFileDownloadLink } from '../../../../services/attachment.service';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Autocomplete, TextField, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import moment from 'moment';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`treat-called-tabpanel-${index}`}
      aria-labelledby={`treat-called-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function TreatCalledModal(props) {
  const { open, onClose, treatCalledData, intl, onAssignCalled, onShowNotification, onCalledClosed, skipAssignment = false } = props;
  const theme = useTheme();
  const [isAssigning, setIsAssigning] = useState(false);
  const [assignSuccess, setAssignSuccess] = useState(false);
  const [treatCalledDetails, setTreatCalledDetails] = useState(null);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [currentTab, setCurrentTab] = useState(0);

  // Estados para a segunda aba
  const [standardActions, setStandardActions] = useState([]);
  const [selectedStandardAction, setSelectedStandardAction] = useState(null);
  const [actionText, setActionText] = useState('');
  const [actionPrivacy, setActionPrivacy] = useState(''); // '' = nenhum selecionado, 'false' = Pública, 'true' = Privada
  const [finalizeStatuses, setFinalizeStatuses] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [loadedStandardActions, setLoadedStandardActions] = useState(false);
  const [loadedStatuses, setLoadedStatuses] = useState(false);

  // Estados para o modal de confirmação de encerramento
  const [confirmClosureDialogOpen, setConfirmClosureDialogOpen] = useState(false);
  const [isClosingCalled, setIsClosingCalled] = useState(false);

  // Estado específico para loading de anexos
  const [isLoadingAttachment, setIsLoadingAttachment] = useState(false);

  // Configurações do ReactQuill
  const reactQuillModules = {
    toolbar: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['link'],
      ['clean']
    ],
  };

  const reactQuillFormats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet',
    'link'
  ];

  //console.log("=== TreatCalledModal renderizado ===");
  //console.log("Props recebidas:", { open, onAssignCalled: typeof onAssignCalled, treatCalledData: !!treatCalledData });
  //console.log("Estados:", { isAssigning, assignSuccess });
  //console.log("Botão Salvar disabled?", !assignSuccess || isAssigning);
  //console.error("treatCalledData:", treatCalledData);

  const fetchTreatCalledDetails = async (calledId) => {
    setIsLoadingDetails(true);
    try {
      const response = await Api.get(`/calleds/treat-called/${calledId}`);
      console.log("Detalhes do chamado:", response.data);
      // O endpoint retorna { success, data, errors } então pegamos response.data.data
      setTreatCalledDetails(response.data.data);

      // Atualizar o status no Redux para refletir o status atualizado após atribuição
      if (response.data.data.statusname && response.data.data.colorhex) {
        const updatedTreatCalledData = {
          ...treatCalledData,
          status: {
            id: response.data.data.statusid,
            name: response.data.data.statusname,
            colorhex: response.data.data.colorhex
          }
        };
        props.setTreatCalledModalData(updatedTreatCalledData);
      }

      return true;
    } catch (error) {
      console.error("Erro ao buscar detalhes do chamado:", error);

      // Mostra notificação de erro
      if (onShowNotification) {
        onShowNotification(
          "error",
          error.response?.data?.errors?.[0] || intl.formatMessage({ id: "process.error" })
        );
      }

      Api.kickoff(error);
      return false;
    } finally {
      setIsLoadingDetails(false);
    }
  };

  const fetchStandardActions = async (organizationId) => {
    if (loadedStandardActions) return true; // Já carregou
    try {
      const response = await Api.get(`/defaultaction/byorganizationid/${organizationId}`);
      if (response && response.data && response.data.success && response.data.data) {
        setStandardActions(response.data.data);
        setLoadedStandardActions(true);
        return true;
      }
      return false;
    } catch (error) {
      console.error("Erro ao buscar ações padrão:", error);
      return false;
    }
  };

  const fetchFinalizeStatuses = async () => {
    if (loadedStatuses) return true; // Já carregou
    try {
      const response = await Api.get('/statuses/finalize');
      if (response && response.data && response.data.success && response.data.data) {
        setFinalizeStatuses(response.data.data);
        setLoadedStatuses(true);
        return true;
      }
      return false;
    } catch (error) {
      console.error("Erro ao buscar status de encerramento:", error);
      if (onShowNotification) {
        onShowNotification("error", intl.formatMessage({ id: "process.error" }));
      }
      return false;
    }
  };

  const handleStandardActionChange = async (event, value) => {
    setSelectedStandardAction(value);
    if (value && value.id) {
      try {
        const response = await Api.get(`/defaultaction/textbyid/${value.id}`);
        if (response && response.data && response.data.success && response.data.data) {
          setActionText(response.data.data);
        }
      } catch (error) {
        console.error("Erro ao buscar detalhes da ação padrão:", error);
        if (onShowNotification) {
          onShowNotification("error", intl.formatMessage({ id: "process.error" }));
        }
      }
    }
  };

  // Função para validar se o texto do ReactQuill tem conteúdo real (não só tags HTML)
  const hasActionTextContent = () => {
    if (!actionText) return false;
    // Remove tags HTML e espaços em branco
    const textOnly = actionText.replace(/<[^>]*>/g, '').trim();
    // Verifica se há conteúdo real
    return textOnly.length > 0;
  };

  // Validação para habilitar o botão "Encerrar Chamado"
  const canFinishCalled = () => {
    return hasActionTextContent() && selectedStatus !== null && actionPrivacy !== '';
  };

  // Função auxiliar para remover tags HTML do texto
  const convertHtmlOption = (html) => {
    if (!html) return null;
    return html.replace(/<[^>]*>/g, '');
  };

  // Função para construir FormData do accompaniment (ação)
  const buildAccompanimentFormData = () => {
    const sanitized = convertHtmlOption(actionText);
    const data = new FormData();

    data.append('description', sanitized && sanitized.length > 0 ? actionText : '#Anexos');
    data.append('calledTitle', treatCalledData.title);
    data.append('privacy', actionPrivacy);
    data.append('called', treatCalledData.id);
    data.append('userAction', props.userSession?.user?.id || 0);

    // Verificar se o status selecionado é de finalização
    const theStatusIsFinish = selectedStatus?.finished === true || selectedStatus?.statustypeid === 5;
    data.append('finish', theStatusIsFinish);
    data.append('originid', 2);

    // Adicionar informações do chamado
    data.append('calledduedDate', treatCalledDetails?.dueDate ? moment(treatCalledDetails.dueDate).endOf('day').format("YYYY/MM/DD HH:mm:ss") : '');

    if (treatCalledDetails?.organizationcategoryid) {
      data.append("OrganizationCategory", treatCalledDetails.organizationcategoryid);
    }

    if (treatCalledDetails?.requestingUser?.id) {
      data.append("requestinguser", treatCalledDetails.requestingUser.id);
    }

    data.append("calledassigneduser", props.userSession?.user?.id || 0);
    data.append("calledobservantuser", 0);
    data.append("calledstatus", selectedStatus?.id || 0);
    data.append("calledid", treatCalledData.id);
    data.append("calledorganizationid", treatCalledData.organizationid || 0);

    data.append("displayassignedinfomode", 0);

    if (treatCalledDetails?.techinicalteam?.id) {
      data.append("CalledTechinicalTeamId", treatCalledDetails.techinicalteam.id);
      data.append("techinicalteamname", treatCalledDetails.techinicalteam.name);
    }

    if (selectedStandardAction?.id) {
      data.append("DefaultActionId", selectedStandardAction.id);
      data.append("DefaultActionTitle", selectedStandardAction.title || selectedStandardAction.name || '');
    }

    data.append('QuickCalledCreated', treatCalledDetails?.quickCalledCreated || false);
    data.append('ClientReopen', false);

    return data;
  };

  // Função para construir FormData do called
  const buildCalledFormData = () => {
    const data = new FormData();

    if (!treatCalledDetails) return data;

    // Adicionar campos do chamado
    if (treatCalledDetails.dueDate) {
      data.append('dueDate', moment(treatCalledDetails.dueDate).format("YYYY/MM/DD HH:mm:ss"));
    }

    data.append("ParentCalledId", treatCalledDetails.ParentCalledId || 0);

    if (treatCalledDetails.requestingUser?.id) {
      data.append("requestinguser", treatCalledDetails.requestingUser.id);
    }

    data.append("assigneduser", props.userSession?.user?.id || 0);

    if (treatCalledDetails.organizationcategoryid) {
      data.append("OrganizationCategory", treatCalledDetails.organizationcategoryid);
    }

    if (treatCalledDetails.techinicalteam?.id) {
      data.append("techinicalTeamId", treatCalledDetails.techinicalteam.id);
    } else {
      data.append("techinicalTeamId", 0);
    }

    if (treatCalledDetails.departamentId?.id) {
      data.append("OrganizationDepartamentId", treatCalledDetails.departamentId.id);
    } else {
      data.append("OrganizationDepartamentId", 0);
    }

    data.append("ObservantUser", 0);
    data.append("status", selectedStatus?.id || 0);
    data.append("id", treatCalledData.id);
    data.append("title", treatCalledData.title);
    data.append("organizationid", treatCalledData.organizationid || 0);

    if (treatCalledDetails.priorityid) {
      data.append("priorityid", treatCalledDetails.priorityid);
    } else if (treatCalledDetails.priority?.id) {
      data.append("priorityid", treatCalledDetails.priority.id);
    } else {
      data.append("priorityid", 0);
    }

    if (treatCalledDetails.addressid) {
      data.append("addressid", treatCalledDetails.addressid);
    } else {
      data.append("addressid", 0);
    }

    data.append("addresstype", treatCalledDetails.addresstype || 1);
    data.append("applicationoriginid", 2);
    data.append("directfinishcalled", false);
    data.append("clientchangestatus", false);
    data.append("displayassignedinfomode", 0);
    data.append("requestinguserId", treatCalledDetails.requestingUser?.id || 0);

    return data;
  };

  // Função principal para encerrar o chamado de forma assíncrona
  const submitAsynchronousClosure = async () => {
    setIsClosingCalled(true);

    try {
      // 1. Construir FormData do accompaniment
      const accompanimentData = buildAccompanimentFormData();

      // 2. Criar newData com prefixo "Accompaniment."
      const newData = new FormData();
      for (const [key, value] of accompanimentData.entries()) {
        newData.append(`Accompaniment.${key}`, value);
      }

      // 3. Construir FormData do called
      const calledData = buildCalledFormData();

      // 4. Criar formDataFinal combinando tudo
      const formDataFinal = new FormData();

      // Adicionar dados do called com prefixo "Called."
      for (const [key, value] of calledData.entries()) {
        formDataFinal.append(`Called.${key}`, value);
      }

      // Adicionar dados do accompaniment (newData) sem prefixo adicional
      for (const [key, value] of newData.entries()) {
        formDataFinal.append(key, value);
      }

      // Adicionar campos personalizados se existirem
      if (treatCalledDetails?.calledorganizationfields && treatCalledDetails.calledorganizationfields.length > 0) {
        treatCalledDetails.calledorganizationfields.forEach((field) => {
          const fieldValue = field.organizationfieldoptionvalues?.name || field.value || '';
          const fieldId = field.organizationfield?.id || 0;
          const fieldOptionsId = field.organizationfieldoptionvalues?.id || 0;

          if (fieldValue) {
            formDataFinal.append("CalledOrganizationField.OrgFieldIdsList", parseInt(fieldId));
            formDataFinal.append("CalledOrganizationField.CalledOrgFieldValuesList", fieldValue);
            formDataFinal.append("CalledOrganizationField.FieldOptionsValuesList", fieldOptionsId);
            formDataFinal.append("CalledOrganizationField.CalledId", treatCalledData.id);
            formDataFinal.append("CalledOrganizationField.IsCalledAccompaniment", true);
          }
        });
      }
      formDataFinal.append("Called.IsQuickCalledTreat", true);

      // 5. Chamar endpoint de encerramento assíncrono
      const result = await Api.put('/calleds/situationrequestasynchronousclosingcalled', formDataFinal);

      if (result.data.success) {
        console.log("=== Encerramento bem-sucedido ===");
        console.log("treatCalledData.id:", treatCalledData.id);

        // Sucesso - mostrar notificação
        if (onShowNotification) {
          onShowNotification("success", intl.formatMessage({ id: "finish.called.redirect" }) || "Chamado encerrado com sucesso!");
        }

        // Remover chamado da lista instantaneamente via window (workaround para cache do webpack)
        if (window.__removeCalledFromList) {
          console.log("=== Chamando window.__removeCalledFromList com ID:", treatCalledData.id);
          window.__removeCalledFromList(treatCalledData.id);
        } else {
          console.error("window.__removeCalledFromList NÃO existe!");
        }

        // Fechar modal
        handleClose();
      } else {
        // Erro no resultado
        if (onShowNotification) {
          onShowNotification("error", result.data.errors?.[0] || intl.formatMessage({ id: "process.error" }));
        }
      }
    } catch (error) {
      console.error("Erro ao encerrar chamado:", error);

      // Tratar erro
      if (onShowNotification) {
        const errorMessage = error.response?.data?.errors?.[0] || intl.formatMessage({ id: "process.error" }) || "Erro ao encerrar chamado";
        onShowNotification("error", errorMessage);
      }
    } finally {
      setIsClosingCalled(false);
      setConfirmClosureDialogOpen(false);
    }
  };

  const handleAssignCalled = async () => {
    console.log("=== handleAssignCalled chamado ===");
    console.log("onAssignCalled existe?", typeof onAssignCalled);

    setIsAssigning(true);
    setAssignSuccess(false);

    try {
      if (!onAssignCalled) {
        console.error("onAssignCalled não foi passado como prop!");
        return;
      }

      const assignResult = await onAssignCalled();
      console.log("Resultado do assignCalled:", assignResult);

      // Se a atribuição falhou, não continua
      if (assignResult === false) {
        console.log("Atribuição falhou. Botão Salvar permanece disabled.");
        handleClose();
        return;
      }

      console.log("Atribuição bem-sucedida! Buscando detalhes do chamado...");

      // Buscar detalhes do chamado após atribuição bem-sucedida
      if (treatCalledData?.id) {
        const fetchResult = await fetchTreatCalledDetails(treatCalledData.id);

        // Só habilita o botão Salvar se AMBOS os endpoints tiveram sucesso
        if (fetchResult === true) {
          setAssignSuccess(true);
          console.log("Ambos os endpoints tiveram sucesso! Botão Salvar habilitado.");

          // Agora buscar ações padrão e status de finalização apenas após sucesso
          if (treatCalledData.organizationid) {
            fetchStandardActions(treatCalledData.organizationid);
          }
          fetchFinalizeStatuses();
        } else {
          console.log("Falha ao buscar detalhes. Botão Salvar permanece disabled.");
        }
      }
    } catch (error) {
      console.error("Erro ao atribuir chamado:", error);
      setAssignSuccess(false);
    } finally {
      setIsAssigning(false);
    }
  };

  // Função para inicializar o modal (pular atribuição se skipAssignment=true)
  const initializeModal = async () => {
    console.log("=== initializeModal chamado ===");
    console.log("skipAssignment:", skipAssignment);

    if (skipAssignment) {
      // Chamado já está atribuído, só buscar detalhes
      console.log("skipAssignment=true, pulando atribuição...");
      setIsAssigning(true);
      try {
        const fetchSuccess = await fetchTreatCalledDetails(treatCalledData.id);
        if (fetchSuccess) {
          setAssignSuccess(true);
          // Carregar ações padrão e status de encerramento
          if (treatCalledData.organizationid) {
            fetchStandardActions(treatCalledData.organizationid);
          }
          fetchFinalizeStatuses();
        } else {
          handleClose();
        }
      } finally {
        setIsAssigning(false);
      }
    } else {
      // Comportamento padrão: atribuir primeiro
      console.log("skipAssignment=false, chamando handleAssignCalled...");
      handleAssignCalled();
    }
  };

  // Chama assignCalled automaticamente quando o modal abre
  useEffect(() => {
    console.log("=== useEffect disparado ===");
    console.log("open:", open);
    console.log("treatCalledData:", treatCalledData);
    console.log("onAssignCalled:", typeof onAssignCalled);
    console.log("skipAssignment:", skipAssignment);

    // Evitar loop: só executa se modal abriu E ainda não está executando E ainda não foi bem-sucedido
    if (open && treatCalledData && !isAssigning && !assignSuccess) {
      // Se skipAssignment=true, não precisa de onAssignCalled
      if (skipAssignment || onAssignCalled) {
        console.log("Condições atendidas! Chamando initializeModal...");
        initializeModal();
      } else {
        console.log("Condições NÃO atendidas. Não vai inicializar.");
      }
    } else {
      console.log("Condições NÃO atendidas. Não vai chamar assignCalled.");
    }
  }, [open, treatCalledData, onAssignCalled, skipAssignment]);

  const getFile = async (attachment) => {
    setIsLoadingAttachment(true);
    try {
      const url = await getFileDownloadLink(attachment.id);
      if (url && url.data && url.data.data && url.data.success) {
        window.open(`${url.data.data}`, '_blank');
      } else {
        if (onShowNotification) {
          onShowNotification("error", intl.formatMessage({ id: "file.not.found" }));
        }
      }
    } catch (error) {
      console.error("Erro ao abrir anexo:", error);
      if (onShowNotification) {
        onShowNotification("error", intl.formatMessage({ id: "process.error" }));
      }
    } finally {
      setIsLoadingAttachment(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleClose = () => {
    // Limpa os dados do Redux ao fechar
    props.clearTreatCalledModalData();
    setAssignSuccess(false);
    setIsAssigning(false);
    setTreatCalledDetails(null);
    setIsLoadingDetails(false);
    setCurrentTab(0);

    // Limpar dados da segunda aba
    setSelectedStandardAction(null);
    setActionText('');
    setActionPrivacy('');
    setSelectedStatus(null);
    setLoadedStandardActions(false);
    setLoadedStatuses(false);

    // Limpar estados de encerramento
    setConfirmClosureDialogOpen(false);
    setIsClosingCalled(false);
    setIsLoadingAttachment(false);

    onClose();
  };

  const handleAdvance = () => {
    // Avança para a segunda aba
    setCurrentTab(1);
  };

  const handleGoBack = () => {
    // Volta para a primeira aba
    setCurrentTab(0);
  };

  const handleFinishCalled = () => {
    // Mostra o modal de confirmação de encerramento
    setConfirmClosureDialogOpen(true);
  };

  const handleCancelClosure = () => {
    // Fecha o modal de confirmação sem encerrar
    setConfirmClosureDialogOpen(false);
  };

  const handleConfirmClosure = () => {
    // Confirma e executa o encerramento
    submitAsynchronousClosure();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={open}
      onClose={handleClose}
      aria-labelledby="treat-called-dialog-title"
    >
      <DialogTitle id="treat-called-dialog-title" style={{ backgroundColor: '#f5f5f5', borderBottom: 'none', paddingBottom: 0 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center" gap={2}>
            <Typography variant="h5" style={{ fontWeight: 600 }}>
              Tratamento Rápido de Chamado
            </Typography>
            {treatCalledData && (
              <Chip
                label={`#${treatCalledData.id}`}
                color="primary"
                size="medium"
                style={{ fontWeight: 600, fontSize: '0.95rem' }}
              />
            )}
          </Box>
          <ClearIcon onClick={handleClose} style={{ cursor: 'pointer', color: '#666' }} />
        </Box>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          style={{ marginTop: 16 }}
        >
          <Tab label="Dados do Chamado" />
          <Tab label="Dados do Encerramento" disabled={!assignSuccess} />
        </Tabs>
      </DialogTitle>

      <DialogContent dividers style={{ padding: '24px' }}>
        {isAssigning ? (
          <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" style={{ height: '60vh' }}>
            <CircularProgress size={60} />
            <Typography variant="body1" color="textSecondary" style={{ marginTop: 20 }}>
              Atribuindo chamado ao técnico...
            </Typography>
          </Box>
        ) : (
          <>
            {/* Aba 1: Dados do Chamado */}
            <TabPanel value={currentTab} index={0}>
              {treatCalledData ? (
                <div style={{ height: '60vh', overflowY: 'auto', overflowX: 'hidden' }}>
                  <Grid container spacing={2}>
            {/* Bloco Principal - Informações do Chamado */}
            <Grid item xs={12}>
              <Card elevation={2}>
                <CardContent>
                  <Grid container spacing={2}>
                    {/* Título */}
                    <Grid item xs={12}>
                      <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Box flex={1}>
                          <Typography variant="caption" color="textSecondary" display="block">
                            Título
                          </Typography>
                          <Typography variant="h6" style={{ fontWeight: 600 }}>
                            {treatCalledData.title}
                          </Typography>
                        </Box>
                        {treatCalledData.status && (
                          <Chip
                            label={treatCalledData.status.name}
                            style={{
                              backgroundColor: treatCalledData.status.colorhex || '#1976d2',
                              color: 'white',
                              fontWeight: 500
                            }}
                          />
                        )}
                      </Box>
                    </Grid>

                    <Grid item xs={12}>
                      <Divider />
                    </Grid>

                    {/* Linha 1: Organização, Categoria, Solicitante */}
                    <Grid item xs={12} sm={4}>
                      <Typography variant="caption" color="textSecondary" display="block">
                        Organização
                      </Typography>
                      <Typography variant="body1" style={{ fontWeight: 500 }}>
                        {treatCalledData.Organization || '-'}
                      </Typography>
                    </Grid>

                    {treatCalledData.OrganizationCategory && (
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" color="textSecondary" display="block">
                          Categoria
                        </Typography>
                        <Typography variant="body1" style={{ fontWeight: 500 }}>
                          {treatCalledData.OrganizationCategory}
                        </Typography>
                      </Grid>
                    )}

                    <Grid item xs={12} sm={4}>
                      <Typography variant="caption" color="textSecondary" display="block">
                        Solicitante
                      </Typography>
                      <Typography variant="body1" style={{ fontWeight: 500 }}>
                        {treatCalledData.requestingusername || treatCalledDetails?.requestingUser?.name || '-'}
                      </Typography>
                    </Grid>

                    {/* Linha 2: Data Abertura, Previsão, Prioridade */}
                    {(treatCalledData.openingdate || treatCalledData.opening || treatCalledDetails?.openingdate) && (
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" color="textSecondary" display="block">
                          Data de Abertura
                        </Typography>
                        <Typography variant="body1" style={{ fontWeight: 500 }}>
                          {treatCalledData.openingdate
                            ? moment(treatCalledData.openingdate).format('DD/MM/YYYY HH:mm')
                            : treatCalledData.opening
                              ? `${treatCalledData.opening} ${treatCalledData.openingHour || ''}`
                              : treatCalledDetails?.openingdate
                                ? moment(treatCalledDetails.openingdate).format('DD/MM/YYYY HH:mm')
                                : '-'}
                        </Typography>
                      </Grid>
                    )}

                    {(treatCalledData.duedate || treatCalledData.dueDt || treatCalledDetails?.dueDate) && (
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" color="textSecondary" display="block">
                          Previsão de Solução
                        </Typography>
                        <Typography variant="body1" style={{ fontWeight: 500 }}>
                          {treatCalledData.duedate
                            ? moment(treatCalledData.duedate).format('DD/MM/YYYY HH:mm')
                            : treatCalledData.dueDt
                              ? `${treatCalledData.dueDt} ${treatCalledData.dueHour || ''}`
                              : treatCalledDetails?.dueDate
                                ? moment(treatCalledDetails.dueDate).format('DD/MM/YYYY HH:mm')
                                : '-'}
                        </Typography>
                      </Grid>
                    )}

                    {treatCalledData.priority && (
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" color="textSecondary" display="block">
                          Prioridade
                        </Typography>
                        <Chip
                          label={treatCalledData.priority.name || 'Normal'}
                          size="small"
                          style={{
                            backgroundColor: treatCalledData.priority.colorhex || '#43A047',
                            color: 'white',
                            fontWeight: 500
                          }}
                        />
                      </Grid>
                    )}

                    {/* Linha 3: Tipo, Departamento, Endereço (se houver) */}
                    {(treatCalledData.typename || treatCalledDetails?.type?.name) && (
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" color="textSecondary" display="block">
                          Tipo
                        </Typography>
                        <Typography variant="body1" style={{ fontWeight: 500 }}>
                          {treatCalledData.typename || treatCalledDetails?.type?.name || '-'}
                        </Typography>
                      </Grid>
                    )}

                    {(treatCalledData.departamentname || treatCalledDetails?.departamentId?.name) && (
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" color="textSecondary" display="block">
                          Departamento
                        </Typography>
                        <Typography variant="body1" style={{ fontWeight: 500 }}>
                          {treatCalledData.departamentname || treatCalledDetails?.departamentId?.name || '-'}
                        </Typography>
                      </Grid>
                    )}

                    {(treatCalledData.addressname || treatCalledDetails?.address?.name) && (
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" color="textSecondary" display="block">
                          Endereço
                        </Typography>
                        <Typography variant="body1" style={{ fontWeight: 500 }}>
                          {treatCalledData.addressname || treatCalledDetails?.address?.name || '-'}
                        </Typography>
                      </Grid>
                    )}
                    {(treatCalledData.requestinguseremail || treatCalledDetails?.requestingUser?.email) && (
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" color="textSecondary" display="block">
                          E-mail do Solicitante
                        </Typography>
                        <Typography variant="body1" style={{ fontWeight: 500 }}>
                          {treatCalledData.requestinguseremail || treatCalledDetails?.requestingUser?.email || '-'}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            {/* Bloco: Conteúdo */}
            <Grid item xs={12}>
              <Card elevation={1}>
                <CardContent>
                  <Box display="flex" alignItems="center" marginBottom={2}>
                    <InfoIcon color="primary" style={{ marginRight: 8 }} />
                    <Typography variant="h6" style={{ fontWeight: 500 }}>
                      {intl.formatMessage({id:"info.contents"})+"("+intl.formatMessage({id:"description"})+")"}
                      
                    </Typography>
                  </Box>
                  <Divider style={{ marginBottom: 16 }} />
                  {isLoadingDetails ? (
                    <Box display="flex" justifyContent="center" padding={2}>
                      <CircularProgress size={30} />
                    </Box>
                  ) : treatCalledDetails?.description ? (
                    <Box
                      style={{
                        maxHeight: '300px',
                        overflowY: 'auto',
                        padding: '8px',
                        border: '1px solid #e0e0e0',
                        borderRadius: '4px',
                        backgroundColor: '#fafafa'
                      }}
                      dangerouslySetInnerHTML={{ __html: treatCalledDetails.description }}
                    />
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      Nenhum conteúdo disponível.
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>

            {/* Bloco: Anexos */}
            <Grid item xs={12}>
              <Card elevation={1}>
                <CardContent>
                  <Box display="flex" alignItems="center" marginBottom={2}>
                    <AttachFileIcon color="primary" style={{ marginRight: 8 }} />
                    <Typography variant="h6" style={{ fontWeight: 500 }}>
                      Anexos
                    </Typography>
                  </Box>
                  <Divider style={{ marginBottom: 16 }} />
                  {isLoadingAttachment ? (
                    <Box display="flex" justifyContent="center" padding={2}>
                      <CircularProgress size={30} />
                    </Box>
                  ) : treatCalledDetails?.calledattachments && treatCalledDetails.calledattachments.length > 0 ? (
                    <Grid container spacing={2}>
                      {treatCalledDetails.calledattachments.map((calledAttachment, index) => {
                        return (
                          <Grid item xs={12} sm={6} md={4} key={calledAttachment.id}>
                            <Box
                              display="flex"
                              alignItems="center"
                              padding="8px 12px"
                              style={{
                                backgroundColor: 'rgba(189, 189, 189, .3)',
                                borderRadius: 4,
                                height: '100%'
                              }}
                            >
                              <AttachFileIcon fontSize="small" color="primary" style={{ marginRight: 8, flexShrink: 0 }} />
                              <Box flex={1} style={{ minWidth: 0 }}>
                                <Button
                                  onClick={() => getFile(calledAttachment.attachment)}
                                  style={{
                                    textTransform: 'none',
                                    fontSize: '0.9rem',
                                    padding: '0',
                                    paddingLeft: '4px',
                                    minWidth: 'auto',
                                    justifyContent: 'flex-start',
                                    width: '100%',
                                    textAlign: 'left',
                                    display: 'block',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                  }}
                                  title={calledAttachment.attachment.description || `Anexo ${index + 1}`}
                                >
                                  {calledAttachment.attachment.description || `Anexo ${index + 1}`}
                                </Button>
                                <Typography variant="caption" color="textSecondary" display="block" style={{ paddingLeft: '4px' }}>
                                  {(calledAttachment.attachment.size / 1024).toFixed(2)} KB
                                </Typography>
                              </Box>
                            </Box>
                          </Grid>
                        );
                      })}
                    </Grid>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      Nenhum anexo disponível.
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>

            {/* Bloco: Campos Personalizados */}
            <Grid item xs={12} style={{ marginBottom: 16 }}>
              <Card elevation={1}>
                <CardContent>
                  <Box display="flex" alignItems="center" marginBottom={2}>
                    <InfoIcon color="primary" style={{ marginRight: 8 }} />
                    <Typography variant="h6" style={{ fontWeight: 500 }}>
                      Campos Personalizados
                    </Typography>
                  </Box>
                  <Divider style={{ marginBottom: 16 }} />
                  {isLoadingDetails ? (
                    <Box display="flex" justifyContent="center" padding={2}>
                      <CircularProgress size={30} />
                    </Box>
                  ) : treatCalledDetails?.calledorganizationfields && treatCalledDetails.calledorganizationfields.length > 0 ? (
                    <Grid container spacing={2}>
                      {treatCalledDetails.calledorganizationfields.map((field) => {
                        const fieldValue = field.organizationfieldoptionvalues?.name || field.value || '-';
                        return (
                          <Grid item xs={12} sm={6} key={field.id}>
                            <Box
                              style={{
                                padding: '12px',
                                backgroundColor: '#f9f9f9',
                                borderRadius: '6px',
                                borderLeft: `3px solid ${theme.palette.primary.main}`,
                                height: '100%'
                              }}
                            >
                              <Typography
                                variant="caption"
                                color="primary"
                                display="block"
                                style={{
                                  fontWeight: 600,
                                  textTransform: 'uppercase',
                                  fontSize: '0.7rem',
                                  letterSpacing: '0.5px',
                                  marginBottom: '4px'
                                }}
                              >
                                {field.organizationfield.name}
                              </Typography>
                              <Typography
                                variant="body1"
                                style={{
                                  fontWeight: 500,
                                  color: '#333',
                                  wordBreak: 'break-word'
                                }}
                              >
                                {fieldValue}
                              </Typography>
                            </Box>
                          </Grid>
                        );
                      })}
                    </Grid>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      Nenhum campo personalizado disponível.
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          </div>
              ) : (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                  <Typography variant="body1" color="textSecondary">
                    Nenhum chamado selecionado.
                  </Typography>
                </Box>
              )}
            </TabPanel>

            {/* Aba 2: Dados do Encerramento */}
            <TabPanel value={currentTab} index={1}>
              <div style={{ height: '60vh', overflowY: 'auto', overflowX: 'hidden' }}>
                <Grid container spacing={3}>
                  {/* Campo 1: Ação Padrão (Autocomplete) */}
                  <Grid item xs={12}>
                    <Card
                      elevation={2}
                      style={{
                        borderLeft: `4px solid ${theme.palette.primary.main}`,
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <CardContent>
                        <Box display="flex" alignItems="center" marginBottom={2}>
                          <PlaylistAddCheckIcon color="primary" style={{ marginRight: 8, fontSize: 28 }} />
                          <Typography variant="h6" style={{ fontWeight: 600, color: '#333' }}>
                            Adicionar Ação Padrão
                          </Typography>
                        </Box>
                        <Divider style={{ marginBottom: 16 }} />
                        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                          Selecione uma ação padrão para preencher automaticamente o campo de ação
                        </Typography>
                        <Autocomplete
                          options={standardActions}
                          getOptionLabel={(option) => option?.name || option?.title || ''}
                          value={selectedStandardAction}
                          onChange={handleStandardActionChange}
                          renderOption={(props, option) => (
                            <Box component="li" {...props}>
                              <Typography>{option?.name || option?.title || ''}</Typography>
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Selecione uma ação padrão"
                              variant="outlined"
                              fullWidth
                            />
                          )}
                          noOptionsText="Nenhuma ação padrão disponível"
                          isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        />
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Campo 2: Ação (ReactQuill) */}
                  <Grid item xs={12}>
                    <Card
                      elevation={2}
                      style={{
                        borderLeft: `4px solid ${theme.palette.primary.main}`,
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <CardContent>
                        <Box display="flex" alignItems="center" marginBottom={2}>
                          <DescriptionIcon color="primary" style={{ marginRight: 8, fontSize: 28 }} />
                          <Typography variant="h6" style={{ fontWeight: 600, color: '#333' }}>
                            Ação Realizada *
                          </Typography>
                        </Box>
                        <Divider style={{ marginBottom: 16 }} />
                        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                          Descreva detalhadamente a ação realizada para encerrar o chamado
                        </Typography>
                        <div style={{
                          resize: "vertical",
                          height: "auto",
                          minHeight: "200px",
                          border: "1px solid #e0e0e0",
                          borderRadius: '6px',
                          marginBottom: 20,
                          overflow: 'hidden'
                        }}>
                          <ReactQuill
                            value={actionText}
                            onChange={setActionText}
                            modules={reactQuillModules}
                            formats={reactQuillFormats}
                            style={{ height: "100%" }}
                            placeholder="Descreva a ação realizada..."
                          />
                        </div>

                        <Box
                          style={{
                            backgroundColor: '#f5f5f5',
                            padding: '16px',
                            borderRadius: '6px',
                            marginTop: 16
                          }}
                        >
                          <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 12, color: '#555' }}>
                            Visibilidade da Ação *
                          </Typography>
                          <FormControl component="fieldset">
                            <RadioGroup
                              aria-label="privacy"
                              name="privacy"
                              value={actionPrivacy}
                              onChange={(e) => setActionPrivacy(e.target.value)}
                              row
                            >
                              <FormControlLabel
                                value="false"
                                control={<Radio color="primary" />}
                                label={intl.formatMessage({ id: "public.action" })}
                                labelPlacement="end"
                                style={{ marginRight: 24 }}
                              />
                              <FormControlLabel
                                value="true"
                                control={<Radio color="primary" />}
                                label={intl.formatMessage({ id: "private.action" })}
                                labelPlacement="end"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Campo 3: Status de Encerramento (Autocomplete) */}
                  <Grid item xs={12} style={{ marginBottom: 16 }}>
                    <Card
                      elevation={2}
                      style={{
                        borderLeft: `4px solid ${theme.palette.success.main}`,
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <CardContent>
                        <Box display="flex" alignItems="center" marginBottom={2}>
                          <CheckCircleIcon style={{ marginRight: 8, fontSize: 28, color: theme.palette.success.main }} />
                          <Typography variant="h6" style={{ fontWeight: 600, color: '#333' }}>
                            Status de Encerramento *
                          </Typography>
                        </Box>
                        <Divider style={{ marginBottom: 16 }} />
                        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                          Selecione o status final do chamado após o encerramento
                        </Typography>
                        <Autocomplete
                          options={finalizeStatuses}
                          getOptionLabel={(option) => option?.name || ''}
                          value={selectedStatus}
                          onChange={(event, value) => setSelectedStatus(value)}
                          renderOption={(props, option) => (
                            <Box component="li" {...props} display="flex" alignItems="center" gap={1}>
                              <Box
                                style={{
                                  width: 16,
                                  height: 16,
                                  borderRadius: '50%',
                                  backgroundColor: option?.colorhex || '#ccc'
                                }}
                              />
                              <Typography>{option?.name || ''}</Typography>
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Selecione o status"
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: selectedStatus ? (
                                  <Box
                                    style={{
                                      width: 16,
                                      height: 16,
                                      borderRadius: '50%',
                                      backgroundColor: selectedStatus?.colorhex || '#ccc',
                                      marginRight: 8,
                                      marginLeft: 8
                                    }}
                                  />
                                ) : null,
                              }}
                            />
                          )}
                          noOptionsText="Nenhum status disponível"
                          isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        />
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </div>
            </TabPanel>
          </>
        )}
      </DialogContent>

      <DialogActions style={{ padding: '16px 24px', backgroundColor: '#f5f5f5', borderTop: '1px solid #e0e0e0' }}>
        <Button onClick={handleClose} size="large" disabled={isAssigning}>
          {intl.formatMessage({ id: "cancel" })}
        </Button>
        <Box flex={1} />
        {currentTab === 1 && (
          <Button onClick={handleGoBack} size="large" disabled={isAssigning}>
            Voltar
          </Button>
        )}
        {currentTab === 0 ? (
          <Button
            variant='contained'
            color='primary'
            size="large"
            onClick={handleAdvance}
            disabled={!assignSuccess || isAssigning}
          >
            Avançar
          </Button>
        ) : (
          <Button
            variant='contained'
            color='primary'
            size="large"
            onClick={handleFinishCalled}
            disabled={!canFinishCalled() || isAssigning}
          >
            Encerrar Chamado
          </Button>
        )}
      </DialogActions>

      {/* Modal de confirmação de encerramento */}
      <Dialog
        open={confirmClosureDialogOpen}
        onClose={isClosingCalled ? null : handleCancelClosure}
        aria-labelledby="confirm-closure-dialog-title"
        maxWidth="xs"
        fullWidth
        disableEscapeKeyDown={isClosingCalled}
      >
        <DialogTitle id="confirm-closure-dialog-title">
          Confirmar Encerramento
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1" style={{ padding: '16px 0' }}>
            Deseja encerrar o chamado?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelClosure} disabled={isClosingCalled}>
            Não
          </Button>
          <Button
            onClick={handleConfirmClosure}
            variant="contained"
            color="primary"
            disabled={isClosingCalled}
          >
            Sim
          </Button>
        </DialogActions>

        {/* Loading overlay por cima do modal */}
        {isClosingCalled && (
          <Box
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999
            }}
          >
            <CircularProgress size={60} />
            <Typography variant="body1" color="textSecondary" style={{ marginTop: 20 }}>
              Encerrando chamado...
            </Typography>
          </Box>
        )}
      </Dialog>
    </Dialog>
  );
}

const mapStateToProps = (state, ownProps) => {
  console.log("=== mapStateToProps ===");
  console.log("ownProps:", ownProps);
  console.log("ownProps.onCalledClosed:", ownProps.onCalledClosed);
  console.log("typeof ownProps.onCalledClosed:", typeof ownProps.onCalledClosed);

  return {
    ...ownProps,
    treatCalledData: state.calleds.treatCalledModalData,
    userSession: state.userSession
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...calledsActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TreatCalledModal));
